<script lang="ts">
import {goto} from "$app/navigation";
import CrownIcon from "$lib/icons/CrownIcon.svelte";
import Button from "$lib/elements/Button.svelte";
import EmojiHappyIcon from "$lib/icons/EmojiHappyIcon.svelte";
import CupIcon from "$lib/icons/CupIcon.svelte";
import {locale, translate} from "$lib/i18n";

</script>

<div class="my-8 bg-primary-blue p-9 rounded-2xl relative overflow-hidden">
  <div class="md:w-3/5 w-full">
    <h2 class="text-xl text-white font-bold mb-4">{$translate('Bet Smarter, Play Harder')}</h2>
    <h3 class="text-primary-lightBlue text-sm mb-6">{$translate('At ForzaBet, we\'re redefining online gaming with over 10,000 slots, thrilling live casino games, and real-time sports betting. Whether you love high-stakes action or prefer casual play, our exclusive bonuses, VIP perks, and dedicated support team make every moment exciting. Step into the world of big wins and unforgettable experiences - it\'s all waiting for you at ForzaBet!')}</h3>
    <Button on:click={() => goto(`/${$locale}/casino`)}>{$translate('Let\'s Go!')}</Button>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-5 my-8">
      <div class="col-span-1">
        <div class="flex items-center text-white">
          <CrownIcon />
          <h4 class="ml-1 text-sm">{$translate('Best Casino Games')}</h4>
        </div>
        <p class="text-primary-lightBlue text-sm mt-2">
          {$translate('Discover the top slots and live games at ForzaBet.')}
        </p>
      </div>
      <div class="col-span-1">
        <div class="flex items-center text-white">
          <CupIcon />
          <h4 class="ml-1 text-sm">{$translate('Win Big Today')}</h4>
        </div>
        <p class="text-primary-lightBlue text-sm mt-2">
          {$translate('Bet, play, and collect amazing rewards daily.')}
        </p>
      </div>
      <div class="col-span-1">
        <div class="flex items-center text-white">
          <EmojiHappyIcon />
          <h4 class="ml-1 text-sm">{$translate('Fast Cashouts')}</h4>
        </div>
        <p class="text-primary-lightBlue text-sm mt-2">
          {$translate('Get your winnings in minutes with easy payouts')}
        </p>
      </div>
    </div>
  </div>
  <img src="/illustrations/stars.svg?enhanced" class="absolute -bottom-16 md:bottom-[unset] -right-[200px] md:right-2.5 md:-top-[90px] animateDesk" alt="Forza.bet - Online Casino Stars">
</div>

<style lang="scss">
  .animateDesk {
    animation: move-across 6s ease-in-out infinite;
  }

  @media (max-width: 1024px) {
    .animateDesk {
      animation: move-across-mobile 6s ease-in-out infinite;
    }
  }

  @keyframes move-across {
    0% {
      top: -90px;
      right: 10px;
    }
    50% {
      top: -80px;
      right: 10px;
    }
    100% {
      top: -90px;
      right: 10px;
    }
  }

  @keyframes move-across-mobile {
    0% {
      bottom: -60px;
      right: -200px;
    }
    50% {
      bottom: -80px;
      right: -200px;
    }
    100% {
      bottom: -60px;
      right: -200px;
    }
  }
</style>
